import React from 'react';
import { Form } from 'react-bootstrap';

const Checkbox = (props) => {
    return (
        <Form.Check type="checkbox" {...props}/>
    );
};

export default Checkbox;